/**
 * DebugConfig - Centralized debug mode detection
 * Avoids duplicate URL parsing throughout the codebase
 */

// Parse URL once and cache the values
let _cachedParams: URLSearchParams | null = null;

function getParams(): URLSearchParams {
    if (_cachedParams === null) {
        _cachedParams = new URLSearchParams(window.location.search);
    }
    return _cachedParams;
}

/**
 * Check if any debug mode is enabled
 */
export function isDebugMode(): boolean {
    return getParams().has('debugPlayer');
}

/**
 * Get the debug player number (1 or 2), or null if not in debug mode
 */
export function getDebugPlayer(): '1' | '2' | null {
    const value = getParams().get('debugPlayer');
    if (value === '1' || value === '2') {
        return value;
    }
    return null;
}

/**
 * Check if we should use the simple debug level (open arena)
 */
export function isDebugLevel(): boolean {
    return getParams().get('debugLevel') === '1';
}

/**
 * Check if the URL specifies a room to automatically create
 */
export function getAutoCreateCode(): string | null {
    return getParams().get('create');
}

/**
 * Check if the URL specifies a room to automatically join
 */
export function getAutoJoinCode(): string | null {
    return getParams().get('join');
}

/**
 * Check if we should use alternate controls (IJKL instead of WASD)
 * Returns true if debugPlayer=2 is present (for legacy support during transition)
 * Note: We are moving toward focus-based controls where everyone uses the same keys.
 */
export function useAlternateControls(): boolean {
    return getDebugPlayer() === '2';
}

/**
 * Clear cached params - useful if URL changes (rarely needed)
 */
export function clearCache(): void {
    _cachedParams = null;
}
